import styled from "@emotion/styled";

export const Container = styled.div`
  margin-top: 100px;
  display: flex;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ContactInfo = styled.div<{ white?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  color: ${props => (props.white ? "white" : "black")};

  .contact-title {
    text-transform: uppercase;
    font-family: Roboto;
    font-size: 25px;
    line-height: 1.4;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    text-align: center;
    letter-spacing: normal;
    color: #f38f1d;
    margin-bottom: 38px;

    /* md-breakpoint */
    @media (min-width: 786px) {
      font-size: 42px;
      line-height: 1.19;
      letter-spacing: 1.75px;
      margin-bottom: 32px;
    }
  }

  .contact-sub_title {
    font-family: Roboto;
    font-size: 21px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;

    p {
      font-size: 18px;
      margin-bottom: 0;
    }
  }
`;

export const ContactForm = styled.div<{ white?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  form {
    width: 80%;

    .input-fields {
      display: flex;
      width: 100%;
      flex-direction: column;
      /* md-breakpoint */
      @media (min-width: 786px) {
        flex-direction: row;
      }

      .label-col {
        width: 100%;
        padding: 10px;

        input:focus {
          outline: none !important;
          border: 1px solid
            ${(props: { theme?: any }) => props.theme.colors.decunifyOrange};
          box-shadow: 0 0 10px
            ${(props: { theme?: any }) => props.theme.colors.decunifyOrange};
        }
      }
    }

    .message-box {
      width: 100%;

      textarea {
        border: solid 1px #ffffff;
        background-color: rgba(216, 216, 216, 0.7);
        resize: none;
        &:focus {
          outline: none !important;
          border: 1px solid
            ${(props: { theme?: any }) => props.theme.colors.decunifyOrange};
          box-shadow: 0 0 10px
            ${(props: { theme?: any }) => props.theme.colors.decunifyOrange};
        }
      }
    }

    .button_row {
      margin-top: 24px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      /* md-breakpoint */
      @media (min-width: 786px) {
        flex-direction: row;
      }

      .button_col {
        display: flex;
        flex-direction: column;
        flex: 1;

        font-family: Roboto;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        font-size: 12px;
        line-height: 1.4;

        .newsletter {
          display: flex;
          color: ${props => (props.white ? "white" : "black")};
        }
        .privacy-group {
          display: flex;
          font-weight: bold;
          height: 34px;
          color: ${props => (props.white ? "white" : "black")};
        }
        .row-submit-button {
          display: flex;
          justify-content: center;
          @media (min-width: 786px) {
            justify-content: flex-end;
          }

          .submit-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-family: Roboto;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 1.5px;
            text-align: center;
            width: 176px;
            height: 45px;
            border: solid 1px #ffffff;
            background-color: #f38f1d;
          }
        }

        .check-box {
          margin-right: 6px;
          width: 18px;
          height: 18px;
        }
      }
    }

    .form-label {
      height: 18px;
      margin-bottom: 5px;
      font-family: Roboto;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: ${props => (props.white ? "white" : "black")};
    }
  }
`;

export const ContactSupport = styled.div<{ white?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 65px;
  margin-bottom: 200px;

  .title-sup {
    font-family: Roboto;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: 5.25px;
    text-align: center;
    margin-bottom: 30px;
    text-transform: uppercase;
    color: ${props => (props.white ? "white" : "black")};
  }
  .title-alert {
    margin-top:60px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: center;
    color: ${props => (props.white ? "white" : "black")};
  }


  .contact-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 60%;
    /* md-breakpoint */
    @media (min-width: 786px) {
      flex-direction: row;
      justify-content: space-evenly;
    }

    .support-info {
      display: flex;
      flex-direction: row;
      justify-content: start;

      /* md-breakpoint */
      @media (min-width: 786px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .support-icon {
        width: 100%;
        height: 34px;
      }
      .sub-title-support {
        margin-right: 10px;
        min-width: 115px;
        font-family: Roboto;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${props => (props.white ? "white" : "black")};

        /* md-breakpoint */
        @media (min-width: 786px) {
          text-align: center;
        }
      }
      .sub-title-suppor-alert {
        font-size: 12px;
      }
    }
  }
`;

export const ContactAddress = styled.div`
  width: 100%;
  margin-top: 55px;
  margin-bottom: 32px;

  .address-orange-box {
    margin: 24px auto;
    width: 76%;
    background-color: #f38f1d;
    display: flex;
    flex-direction: column;

    /* md-breakpoint */
    @media (min-width: 786px) {
      width: 276px;
    }
    /* xl-breakpoint */
    @media (min-width: 1260px) {
      min-width: 276px;
    }

    .address-info {
      /* md-breakpoint */
      @media (min-width: 786px) {
        min-height: 312px;
      }
      /* xl-breakpoint */
      @media (min-width: 1260px) {
        min-height: 276px;
      }

      .address-title {
        font-weight: bold;
      }
      .city,
      .company-address,
      .company-phone,
      .company-fax,
      .directions {
        font-family: Roboto;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #000000;
        margin: 12px 24px;
      }
      .get-directions{
        color: black;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        text-decoration:underline;
      }
      .phone-alert{
        font-family: Roboto;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #000000;
        margin-top:4px;
      }
      .city,
      .directions {
        height: 28px;
        font-size: 18px;
        line-height: 1.28;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-top: 24px;
        margin-bottom: 24px;
      }
      .city {
        color: #ffffff;
      }
      .directions {
        display: flex;
        flex-direction: row;

        font-family: Montserrat;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;

        img {
          margin-left: 10px;
          width: 8px;
          height: 12px;
          filter: brightness(0%);
        }
      }
    }

    .map {
      width: 100%;
      height: 400px;
      .marker {
        width: 100%;
        height: 400px;
      }
    }
  }
`;
